import React from 'react'

export const Filter = () => {
    return (
        <>
            <div className="ml-24 translate-y-8">
                <p className="bg-white px-12 w-max">Busqueda</p>
            </div>
            <div className="border-2 rounded-lg">
                <div className="w-full grid grid-cols-3 gap-4 my-6">
                    <div className="pt-8">
                    </div>
                </div>
            </div>
        </>
    )
}
